import {Grid} from '@material-ui/core'
import {_} from 'i18n'
import React from 'react'

import {ContainerHeader, DetailContainer, Paper} from '../styles'

var groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

const StateAttachments = ({multimedia}) => {
  if (!multimedia) {
    return (
      <Paper>
        <ContainerHeader>{_`Arquivos Sobre o Estado`}</ContainerHeader>
        <DetailContainer>
          <h3>{_`Informação não preenchida pelo Estado`}</h3>
        </DetailContainer>
      </Paper>
    )
  }

  const grouped = groupBy(multimedia, 'type')

  return (
    <Paper>
      <ContainerHeader>{_`Arquivos Sobre o Estado`}</ContainerHeader>
      <DetailContainer>
        <Grid container>
          <Grid item lg={4}>
            {grouped['image'] ? (
              <div>
                <span className="secundary-title">{_`Fotos`}</span>
                <br />
                <br />
                <ul className="image-files" style={{display: 'flex'}}>
                  {grouped['image'].map((file, index) => (
                    <a key={index} href={file.path} target="_blank" rel="noopener noreferrer">
                      <li style={{backgroundImage: `url(${file.path})`, backgroundSize: 'cover', marginRight: 10}}></li>
                    </a>
                  ))}
                </ul>
              </div>
            ) : null}
          </Grid>
          <Grid item lg={4}>
            {grouped['document'] ? (
              <div>
                <span className="secundary-title">{_`Documentos`}</span>
                <br />
                <br />
                <ul className="image-files" style={{display: 'flex'}}>
                  {grouped['document'].map((file, index) => (
                    <a key={index} href={file.path} target="_blank" rel="noopener noreferrer">
                      <li
                        style={{
                          backgroundImage: 'url(https://i.imgur.com/ZmTELra.png)',
                          backgroundSize: 'cover',
                          marginRight: 10,
                        }}></li>
                    </a>
                  ))}
                </ul>
              </div>
            ) : null}
          </Grid>
          <Grid item lg={4}>
            {grouped['video'] ? (
              <div>
                <span className="secundary-title">{_`Videos`}</span>
                <br />
                <br />
                <ul className="image-files" style={{display: 'flex'}}>
                  {grouped['video'].map((file, index) => (
                    <a key={index} href={file.path} target="_blank" rel="noopener noreferrer">
                      <li
                        style={{
                          backgroundImage: 'url(https://i.imgur.com/ZmTELra.png)',
                          backgroundSize: 'cover',
                          marginRight: 10,
                        }}></li>
                    </a>
                  ))}
                </ul>
              </div>
            ) : null}
          </Grid>
        </Grid>
      </DetailContainer>
    </Paper>
  )
}

export default StateAttachments
